export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00842.c6fee949.png";